import styled from 'styled-components';

export const QuizBlockRoot = styled.div`
  --quiz-accent-fallback: #4f46e5;
  width: 100%;
  margin: 8px 0;
  color: inherit;
  font-family: inherit;

  .quiz-title {
    margin: 0 0 18px;
    font-size: 22px;
    font-weight: 700;
    line-height: 1.3;
    text-align: center;
  }

  .quiz-subtitle {
    margin: 0 0 16px;
    font-size: 15px;
    line-height: 1.5;
    text-align: center;
    opacity: 0.8;
  }

  .quiz-subtitle b,
  .quiz-subtitle strong {
    color: var(--quiz-accent, var(--quiz-accent-fallback));
  }

  .quiz-card {
    border: 1px solid rgba(15, 23, 42, 0.08);
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.9);
    box-shadow: 0 6px 20px rgba(15, 23, 42, 0.06);
  }
`;
